import React, { useEffect, useRef, useState, useCallback } from "react";
import { useTranslation } from 'react-i18next';
import axios from "axios";
import Totals from "./Totals.jsx";
import ConfirmRemovePendingUser from "./ConfirmRemovePendingUser.jsx";

const CartButtons = ({
    rootUrl,
    handleLinkClick,
    crewcartMember,
    userToken,
    crewCartToken,
    crewCart,
    currencyFormatter
}) => {
    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);
    const [shoppingComplete, setShoppingComplete] = useState(false);
    const [userCheckingOut, setUserCheckingOut] = useState({});
    const[cancelCheckoutLoading, setCancelCheckoutLoading] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    useEffect(() => {
        setCancelCheckoutLoading(false);
        if(crewCart.status == "checking_out") {
            //loop over all crewcart.members and setUserCheckingOut
            for(let i = 0; i < crewCart.members.length; i++) {
                if(crewCart.members[i].id == crewCart.checkout_initiated_by_member_id) {
                    setUserCheckingOut(crewCart.members[i]);
                    break;
                }
            }
        } else {
            // Clear the userCheckingOut when status is not "checking_out"
            setUserCheckingOut({});
        }
    }, [crewCart]);



    useEffect(()=>{
        console.log("shopping complete");
        console.log({crewcartMember});
        setShoppingComplete(crewcartMember?.status == "DONE");
    }, [crewcartMember]);
    const updateStatus = async function(shoppingComplete) {
        await axios.post(`${rootUrl}/api/crewcart/member/status/${shoppingComplete}`, {
            user_token: userToken, // Use ref for the latest userToken
            cart_token: crewCartToken,
        });
    }
    const handleCancelCheckout = async () =>{

        setCancelCheckoutLoading(true);
        await axios.post(`${rootUrl}/api/crewcart/checkout/cancel`, {
            user_token: userToken, // Use ref for the latest userToken
            cart_token: crewCartToken,
        });

    }

    const   handleContinueShopping = async () => {

        if(shoppingComplete) {
            setLoading(true);
            await updateStatus(!shoppingComplete);
            setShoppingComplete(!shoppingComplete);
            setLoading(false);
        }
            window.parent.postMessage(
                {type: 'CONTINUE_SHOPPING'},
                'https://' + crewCart.shop.origin_domain
            );
    }
    const handleDoneShopping = async function() {

        console.log("setting shopping complete to opposite of ", shoppingComplete)

        setLoading(true);
        await updateStatus(!shoppingComplete);
        setLoading(false);
        setShoppingComplete(!shoppingComplete);
        handleLinkClick("cart-overview")
    }


    const initiateCheckout = async function() {
        setLoading(true);
        try {
            let res = await axios.post(`${rootUrl}/api/crewcart/checkout`, {
                user_token: userToken, // Use ref for the latest userToken
                token: crewCartToken,
            });

            if(res.status == 200){

                if(res?.data?.checkout_url) {
                    //redirect top window from iframe
                    window.parent.postMessage(
                        { type: 'REDIRECT', checkout_url : res?.data?.checkout_url },
                        'https://' + crewCart.shop.origin_domain
                    );
                }
            }
        } catch (err) {
            console.log(err.message);
            setLoading(false);
        }
    }
    const handleCheckout = async function() {


        let allComplete = crewCart?.members?.filter(member => member.status != 'DONE').length == 0;

        if(!allComplete) {
            //we need to show a confirmation react screen, and need add the initiate checkout function in it
            setShowConfirm(true);
        }else{
            await initiateCheckout();
        }

    };

    return (
        <div className={showConfirm ? "checkout-button-container confirm" :"checkout-button-container"} style={{
            position: showConfirm ? 'fixed' : 'sticky',
            top: showConfirm ? '0' : 'auto',
            left: showConfirm ? '0' : 'auto',
            right: showConfirm ? '0' : 'auto',
            bottom: showConfirm ? '0' : '0',
            height: showConfirm ? '85%' : 'auto',
            zIndex: showConfirm ? '709' : 'auto',
            background: '#fff',
            padding: showConfirm ? '0' : '15px',
            margin: showConfirm ? '6px' : '0',
            width: showConfirm ? 'auto' : 'auto',
        }}>
            { showConfirm && <ConfirmRemovePendingUser userToken={userToken} crewCartToken={crewCartToken} rootUrl={rootUrl} crewCart={crewCart} setShowConfirm={setShowConfirm} initiateCheckout={initiateCheckout}/>}
            {!showConfirm && (
                <>
                    <Totals crewCart={crewCart} currencyFormatter={currencyFormatter} loading={loading}/>

                    {crewcartMember.status == "DONE" && crewCart?.members?.filter(member => member.status != 'DONE').length > 0 && (
                        <div className="subtext text-center pb-1">
                            {t('overview.wait')}
                        </div>
                    )}

                    {userCheckingOut?.name && (
                        <div className={"subtext text-center pb-1"}>{t('overview.checkoutInProgress')} {userCheckingOut.name}. {t('overview.hold')}</div>
                    )}
                    <div className="button-group" style={{
                        display: 'flex',
                        gap: '10px',
                        justifyContent: 'space-between',
                    }}>
                        <button
                            className="btn btn-outline-secondary"
                            disabled={loading || (crewCart?.status != "open" && crewCart?.checkout_initiated_by_member_id != crewcartMember.id)}
                            onClick={crewCart?.checkout_initiated_by_member_id == crewcartMember.id ? handleCancelCheckout : handleContinueShopping}
                            style={{
                                backgroundColor: 'white',
                                border: '1px solid black',
                                color: 'black',
                                padding: '10px 20px',
                                borderRadius: '0',
                                flex: '1',
                                height: '42px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            {cancelCheckoutLoading ? (
                                    <img
                                        src="/images/loading_white_transparent.gif"
                                        width={20}
                                        style={{marginTop: '-5px'}}
                                    />
                                ) :
                                crewCart?.checkout_initiated_by_member_id != null &&  crewCart?.checkout_initiated_by_member_id == crewcartMember?.id ? t('overview.cancelCheckout') : t('overview.continueShopping')
                            }
                        </button>

                        <button
                            disabled={loading || crewCart?.status !== "open" || crewCart?.items?.length <= 0 }
                            className={`btn ${shoppingComplete ? 'btn-primary-crewcart btn-crewcart-checkout' : 'btn-primary-crewcart rounded-0 done-shopping'}`}
                            type="button"
                            onClick={shoppingComplete ? handleCheckout : handleDoneShopping}
                            style={{
                                flex: '1',
                                padding: '10px 20px',
                                height: '42px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            {(loading || crewCart.status === 'checking_out') ? (
                                <img
                                    src="/images/loading_white_transparent.gif"
                                    width={20}
                                    style={{marginTop: '-5px'}}
                                />
                            ) : (
                                shoppingComplete ? (
                                        <>
                                            {t('cartItems.checkout')} <span className="text-xl ml-2">→</span>
                                        </>
                                ) : (
                                    t('cartItems.doneShopping')
                                )
                            )}
                        </button>
                    </div>
                    <div className="subtext">
                        {shoppingComplete ? t('overview.subText') : t('cartItems.doneShoppingInfo')}
                    </div>
                </>
            )}
        </div>
    );
};

export default CartButtons;
